import { BrandfolderHexColors } from '@brandfolder/react';
import { css } from 'styled-components';

export const drop = css`
  background-color: transparent;
  border-color: transparent;
  border-style: solid;
  border-width: 2px;
  transition:
    background-color 0.1s ease,
    border-color 0.1s ease,
    border-style 0.1s ease,
    height 0.1s ease,
    width 0.1s ease;
`;

export const dropDragging = css`
  border-color: ${BrandfolderHexColors.PurplePopsicle};
`;

export const dropOver = css`
  background-color: ${BrandfolderHexColors.DirtyMarshmallow};
  border-color: ${BrandfolderHexColors.PurplePopsicle};
  border-style: dashed;
  border-width: 2px;
`;
